import { render, staticRenderFns } from "./Accidents.vue?vue&type=template&id=406afefe&scoped=true"
import script from "./Accidents.vue?vue&type=script&lang=js"
export * from "./Accidents.vue?vue&type=script&lang=js"
import style0 from "./Accidents.vue?vue&type=style&index=0&id=406afefe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406afefe",
  null
  
)

export default component.exports